<div>
  <div data-dgat="tracker-5c2" *ngIf="trackerSteps | async as steps">
    <button
      *ngFor="let step of steps"
      data-dgat="tracker-e83"
      [routerLink]="[step.stepUrl]"
      [disabled]="step.isDisabled"
      [attr.aria-label]="
        step.isActive
          ? ('A11y_TrackerCurrentStep'
            | translate: { stepName: step.stepDisplayName })
          : ('A11y_TrackerStep' | translate: { stepName: step.stepDisplayName })
      "
      (click)="onTrackerClicked(step)"
    >
      <df-icon
        icon="record"
        size="extra-small"
        [ngClass]="{
          '__step-dot--active': step.isActive,
          '__step-dot--inactive': step.isDisabled
        }"
        class="__step-dot"
      ></df-icon>
    </button>
  </div>
</div>
